import AjaxLoadedWebsiteModal from "webPage/modal/AjaxLoadedWebsiteModal";
import WebsiteModal from "webPage/modal/WebsiteModal";

export default class VideoModal extends WebsiteModal {
    constructor(videoId) {
        super({
            close: {
                background: false,
            },
        });
        this.videoId = videoId;
    }

    buildElement() {
        this.$modal = AjaxLoadedWebsiteModal.global_settings.buildLoadingModal();
        this.$modal.find('.modal__close').remove();
        this.$modal.addClass('modal--video').find(".modal__content").append(
            eotwJSXFactory('div', {className: 'modal__video'}, [
                eotwJSXFactory('iframe', {src: "https://player.vimeo.com/video/" + this.videoId, frameBorder: "0", webkitallowfullscreen: true, mozallowfullscreen: true, allowFullScreen: true})
            ])
        );
        this.$modal.append(
            eotwJSXFactory('button', {className: "modal__close js-close-modal", title: "Close", 'aria-label': "Close Modal"}, [eotwJSXFactory('span', {className: "modal__close-icon"})])
        );
    }

    destroy() {
        super.destroy();
    }
}
